<template>
  <div class="page">
    <div class="card-login">
      <div class="card-header">
        <img class="brand" :src="brand" alt />
      </div>
      <div class="card-body">
        <div class="greeting">
          <span class="title">{{
            greeting.greeting ? greeting.greeting : "Hello,"
          }}</span>
          <p class="subtitle">
            {{
              greeting.subgreeting ? greeting.subgreeting : "Have a good day!"
            }}
          </p>
        </div>
        <div class="body">
          <el-form
            size="small"
            :model="formRule"
            status-icon
            :rules="rules"
            ref="formRule"
            class="demo-ruleForm"
          >
            <el-form-item prop="tlc" size="medium">
              <el-input
                maxlength="3"
                placeholder="Tlc"
                v-model.number="formRule.tlc"
              >
                <i slot="prefix" class="el-input__icon el-icon-user" />
              </el-input>
            </el-form-item>
            <el-form-item prop="pass" size="medium">
              <el-input
                show-password
                placeholder="Password"
                type="password"
                v-model="formRule.pass"
                autocomplete="off"
              >
                <i slot="prefix" class="el-input__icon el-icon-key"
              /></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                class="button-block"
                type="primary"
                :loading="loading.submit"
                @click="signIn('formRule')"
                >Sign In</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
      :modalAppendToBody="false"
      @opened="onOpenModal"
      :width="isMobile?'95%' : '800px'"
      :visible.sync="modal.agreement"
      :close-on-click-modal="false"
      :show-close="false"
      top="2vh"
      class="modal_nda"
    >
      <span slot="title"><i class="el-icon-s-check"></i> NON DISCLOSURE AGREEMENT</span>
      <div id="nda_div" v-html="modal.htmlcontent" :class="isMobile ? 'content_nda mbl' : 'content_nda dsk'"></div>
      <div style="display: flex;justify-content: end;margin-top:5px">
        <el-button type="secondary" size="small" icon="el-icon-plus" @click="zoomIn"></el-button>
        <el-button type="secondary" size="small" icon="el-icon-minus" @click="zoomOut" style="margin-left: 0px;"></el-button>
      </div>
      <el-checkbox v-model="modal.iagree" :disabled="modal.iagree_disable" class="mtop">I Agree</el-checkbox>
      <div v-if="modal.iagree" style="width: 100%;" >
        <div class="mtop">Please sign your signature on area below.</div>
        <div style="background:rgb(239,239,239)">
          <vueSignature
            v-if="modal.isON"
            ref="signature"
            :sigOption="modal.option"
            :w="'auto'"
            :h="modal.signatureHeightArea"
            :disabled="false"
            class="dsignature"
          ></vueSignature>
        </div>
        <el-button type="danger" size="small" @click="canvasClear" class="dsignature-btn">Clear Area</el-button>
        <el-button type="primary" class="dsignature-btn2" 
          @click="saveNDA"
          :loading="modal.load_save" style="margin-left: 0px;">Submit</el-button>
      </div>
      <div style="display:none">
        <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="false"
          filename="hee hee"
          :manual-pagination="false"
          ref="html2Pdf"
          pdf-content-width="640px"
          :paginate-elements-by-height="500"
          :html-to-pdf-options="htmlToPdfOptions"
          @beforeDownload="beforeDownload($event)"
          @hasDownloaded="hasDownloaded($event)"
          @hasGenerated="hasGenerated($event)"
        >
            <section slot="pdf-content">
                <!-- PDF Content Here -->
                <div v-html="modal.htmlcontent" class="content_nda"></div>
            </section>
        </vue-html2pdf>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { gsap } from "gsap";
import htmlcontentSource from '@/assets/NonDisclosureAggrement_source.htm'
import vueSignature from "vue-signature";
import VueHtml2pdf from 'vue-html2pdf'
import html2pdf from 'html2pdf.js'
import CryptoJS from "crypto-js";
import dayjs from "dayjs";

require('dayjs/locale/id')
const moment = dayjs;

export default {
  name: "Login",
  components: {
    vueSignature,
    VueHtml2pdf
  },
  data() {
    return {
      modal:{
        tempUsrActive: null,
        isON: true,
        isPotrait: true,
        signatureHeightArea: '80vw',
        htmlcontentSource,
        agreement: false,
        NotAllowedLogin: false,
        htmlcontent: null,
        iagree: false,
        iagree_disable: true,
        option: {
          penColor: "rgb(0, 0, 0)",
          backgroundColor: "#efefef00",
        },
        style:{
          fontSize: 14,
          width: 100
        },
        load_save: false
      },
      formRule: {
        pass: "",
        tlc: "",
      },
      rules: {
        tlc: [
          {
            required: true,
            message: "Please Input Your TLC!",
            trigger: "blur",
            min: 3,
            max: 3,
          },
        ],
        pass: [
          {
            required: true,
            message: "Please Input Your Password!",
            trigger: "blur",
          },
        ],
      },
      loading: {
        submit: false,
      },
      url: process.env.VUE_APP_BACKEND,
      isBackgroundExist: false,
      htmlToPdfOptions: {
        margin: [2,2,2,2],
    
        filename: `nda.pdf`,
    
        image: {
            type: 'png', 
            quality: 1
        },
    
        enableLinks: false,
    
        html2canvas: {
            scale: 1,
            useCORS: false,
            logging: true,
            dpi: 192,
            letterRendering: true
        },
    
        jsPDF: {
            unit: 'cm',
            format: 'a4',
            orientation: 'portrait'
        }
      }
    };
  },
  beforeCreate() {
    this.$store.dispatch("setLogout");
  },
  async created() {
    this.$store.dispatch("setLogout");
  },
  computed: {
    ...mapGetters({ background: "getBackground" }),
    greeting() {
      let date = new Date();
      let time = date.getHours();
      let greeting = "";
      let subgreeting = "";

      if (time < 12) {
        greeting = "Good Morning";
        subgreeting = "Hope your day will be great!";
      }
      if (time >= 12) {
        greeting = "Good Afternoon";
        subgreeting = "Stay Focus!";
      }
      if (time >= 17 && time < 19) {
        greeting = "Family Time!";
        subgreeting =
          "What can you do to promote world peace? Go home and love your family!";
      }
      if (time >= 19 && time < 24) {
        greeting = "Good Night";
        subgreeting =
          "Turn of your computer, Your future depends on your dreams, so go to sleep!";
      }

      return { time: time, greeting: greeting, subgreeting: subgreeting };
    },
    brand() {
      return require("@/assets/logo/pandapakita/pandapakita-logo.png");
    },
  },
  mounted() {
    window.addEventListener("resize", this.isPotrait);
    this.isPotrait()

    this.$store.dispatch("getBackground", { etag: null });
    var self = this;
    window.addEventListener("keyup", function(event) {
      if (event.keyCode === 13) {
        self.signIn();
      }
    });
    if (!this.isMobile) {
      if (this.doesFileExists(this.background.desktop) == false) {
        this.isBackgroundExist = false;
      } else {
        this.isBackgroundExist = true;
      }
    } else if (!this.isMobile) {
      if (this.doesFileExists(this.background.mobile) == false) {
        this.isBackgroundExist = false;
      } else {
        this.isBackgroundExist = true;
      }
    }

    if (this.isbackgroundExist) {
      this.$notify.error({
        title: `Background Error!`,
        message:
          "Your Background is broken, please contact your administrator ",
      });
    }
    this.startAnimation();
  },
  unmounted() {
    window.removeEventListener("resize", this.isPotrait);
  },
  methods: {
    moment,
    signIn(formRule) {
      if(this.$refs["formRule"])
      this.$refs["formRule"].validate(async (valid) => {
        if (valid) {
          const { dispatch } = this.$store;
          this.loading.submit = true;
          await dispatch("setLogin", {
            tlc: this.formRule.tlc,
            password: this.formRule.pass,
          })
            .then(async (response) => {
              let trigger = true
              let user = JSON.parse(localStorage.getItem("token"));
              await dispatch("setActiveUser", { token: user.token }).then(async (data) => {
                this.modal.tempUsrActive = data
                await dispatch("getLoginSSO", {
                  tlc: this.formRule.tlc,
                  password: this.formRule.pass,
                }).catch(async (err)=>{
                  let responses = Object.assign({}, err.response);
                  if(responses.data && responses.data.error && responses.data.error=='invalid_grant'){
                      trigger = false
                      this.gotoPoinAgreement()
                    // await dispatch("reGenerateSecureSSO", {
                    //   tlc: this.formRule.tlc,
                    //   psw: this.formRule.pass,
                    //   tokenPandapakita: user.token
                    // }).then(() => {
                    //   trigger = false
                    //   this.gotoPoinAgreement()
                    // }).catch((err)=>{
                    //   let responses2 = Object.assign({}, err.response);
                    //   if(responses2.data && responses2.data && responses2.data.error=="invalid_grant"){
                    //     this.$notify.error({
                    //       title: `Login Failed`,
                    //       message: "SSO username or password is not valid!",
                    //     });
                    //     this.loading.submit = false;
                    //   }
                    //   trigger = false
                    // })
                  }else if(responses.length==undefined){
                    trigger = false
                    this.$notify.error({
                      title: `Login Failed`,
                      message: "SSO Server unreachable!",
                    });
                    this.loading.submit = false;
                  }
                })

                if(trigger){
                  this.reloadHome()
                }
              });
            })
            .catch((error) => {
              this.$notify.error({
                title: "Error",
                message: error.response.data.error,
              });
              this.loading.submit = false;
            });
        } else {
          this.$notify.error({
            title: "Error",
            message: "Please check your account!",
          });
        }
      });
    },
    async dismiss() {
      this.deferredPrompt = null;
    },
    async install() {
      this.deferredPrompt.prompt();
    },
    startAnimation() {
      gsap.from(".card-login", {
        y: -10,
        duration: 3,
        ease: "elastic",
      });
      gsap.from(".brand, .greeting>.title, .greeting>.subtitle ", {
        opacity: 0,
        y: 10,
        duration: 0.2,
        delay: 0.2,
        ease: "circ.inOut",
      });
    },
    gotoPoinAgreement(){
      // if(!this.isMobile){
      //   this.modal.NotAllowedLogin = true;
      //   this.$notify.warning({
      //     title: `Attention!`,
      //     message:
      //       "Please Acces via Mobile to Accept `NON DISCLOSURE AGREEMENT` first!",
      //     duration: null
      //   });
      //   this.loading.submit = false;
      // }else{
        this.modal.NotAllowedLogin = true;
        this.modal.agreement = true;
      // }
    },
    canvasClear(){
      this.$refs.signature.clear();
    },
    onOpenModal(){
      this.modal.htmlcontentSource = this.modal.htmlcontentSource
      // .replaceAll('.Section1{}','.Section1{word-break: break-word;font-size: '+this.modal.style.fontSize+'px;width: '+this.modal.style.width+'%;')
      // .replaceAll('.Section1{}','.Section1{word-break: break-word;width: '+this.modal.style.width+'%;')
      // .replaceAll('#TLCNDA#', this.modal.tempUsrActive.details.nama.toUpperCase())
      .replaceAll('#KARYAWAN_NM1#', this.modal.tempUsrActive.details.nama.toUpperCase())
      .replaceAll('#KARYAWAN_NM#', this.modal.tempUsrActive.details.nama)
      // .replaceAll('#KARYAWAN_TLC#', this.modal.tempUsrActive.details.tlc)
      .replaceAll('#JABATAN_TLC#', this.modal.tempUsrActive.data.posisi+" - "+this.modal.tempUsrActive.data.divisi)
      // .replaceAll('#TAHUN#', this.moment().format('YYYY'))
      // .replaceAll('#BULAN#', this.moment().locale('id').format('MMMM'))
      // .replaceAll('#TGL#', this.moment().format('D'))
      this.modal.htmlcontent = this.modal.htmlcontentSource
      //const el_nda = document.querySelector("#nda_div");
      //el_nda.onscrollend = (event) => {
      //  if(Math.abs(event.target.scrollHeight - event.target.clientHeight - event.target.scrollTop) <= 50){
          this.modal.iagree = false
          this.modal.iagree_disable = false
      //  }
      //};
    },
    reloadHome(){
      this.$notify.success({
        title: `Welcome`,
        message: "Login Successfully!",
      });
      this.$router.push({ name: "Home" });
      this.loading.submit = false;
    },
    async saveNDA(){
      if(this.$refs.signature.isEmpty()){
        this.$notify.warning({
          title: `Warning!`,
          message:
            "Please sign your signature first!",
        });
      }else{
        // let png = this.$refs.signature.save();
        // let a = document.getElementsByClassName('ttdtlc');
        // console.log("a",a)
        // a.forEach((element) => {
        //   element.innerHTML = '<img src="'+png+'" alt="Red dot" />'
        //   // element.style.display = 'block'
        // });

        this.generateReport()
      }
    },
    zoomIn(){
      if(this.modal.style.fontSize<20){
        this.modal.htmlcontent = null
        this.modal.style.fontSize = this.modal.style.fontSize+1
        this.modal.style.width    = this.modal.style.width+10
        this.modal.htmlcontent = this.modal.htmlcontentSource
          .replaceAll('.C_NDA{font-size: 14px;}',
            '.C_NDA{font-size: ' +this.modal.style.fontSize+'px;width: '+this.modal.style.width+'%;')
      }
    },
    zoomOut(){
      if(this.modal.style.fontSize>14){
        this.modal.htmlcontent = null
        this.modal.style.fontSize = this.modal.style.fontSize-1
        this.modal.style.width    = this.modal.style.width-10
        this.modal.htmlcontent = this.modal.htmlcontentSource
          .replaceAll('.C_NDA{font-size: 14px;}',
            '.C_NDA{font-size: ' +this.modal.style.fontSize+'px;width: '+this.modal.style.width+'%;')
      }
    },
    isPotrait(){
      let a = window.matchMedia("(orientation: portrait)").matches ? true : false;
      if(a!=this.modal.isPotrait){
        this.modal.isPotrait = a
        this.modal.signatureHeightArea = a ? '80vw' : '80vh' ;
        this.modal.isON = false
        setTimeout(() => {this.modal.isON=true}, 100);
      }
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages()
          for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i)
              // pdf.setFontSize(18)
              // pdf.setTextColor(100)
              pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() / 2.3), (pdf.internal.pageSize.getHeight() - 0.8))
          } 
      }).save()
      return false;
    },
    hasDownloaded(val){
    },
    hasGenerated(val){
    },
    async blobToBase64(blob) {
      return await new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    async generateReport () {
      this.modal.load_save = true
      let png = this.$refs.signature.save();
      // let a = document.getElementsByClassName('ttdtlc');
      // a.forEach((element) => {
      //   element.innerHTML = '<img src="'+png+'" alt="Red dot" />'
      // });
      // // this.$refs.html2Pdf.generatePdf();
      // let src = this.$refs.html2Pdf

      // const html2PdfSetup = html2pdf().set(src.$options.propsData.htmlToPdfOptions).from(src.$refs.pdfContent)
      // let res = await html2PdfSetup.output('bloburl')
      // // this.$refs.html2Pdf.downloadPdf();

      // let ndaFiles = null
      let succesSavingNDA = true
      await fetch(png).then(async r => {
        let ndaSignature = await r.blob()
        await this.$store.dispatch("saveNDAPandapakita", {
          tlc: this.formRule.tlc,
          password: CryptoJS.MD5(this.formRule.pass).toString(),
          file: ndaSignature
        }).catch(()=>{
          succesSavingNDA = false
        })
      }).catch(()=>{
        succesSavingNDA = false
      })
      
      if(!succesSavingNDA){
        localStorage.removeItem("token");
        this.modal.load_save = false
        this.$notify.error({
          title: `Error!`,
          message:
            "Error Saving Files Evidance NDA!",
        });
      }else{
        let signatures = null
        await fetch(png)
        .then(res => res.blob())
        .then((res2)=>{signatures = res2})

        await this.$store.dispatch("setLogin", {
          tlc: this.formRule.tlc,
          password: this.formRule.pass,
        })
        .then(async () => {
          let user = JSON.parse(localStorage.getItem("token"));
        
          await this.$store.dispatch("changeProfile", {
            old_pass: this.formRule.pass,
            new_pass: this.formRule.pass,
            confirm_pass: this.formRule.pass,
            signature: signatures,
            token: user.token,
            notReloadToHome: true
          }).then(async () => {
              let user = JSON.parse(localStorage.getItem("token"));
              await this.$store.dispatch("reGenerateSecureSSO", {
                tlc: this.formRule.tlc,
                psw: this.formRule.pass,
                tokenPandapakita: user.token
              }).then(() => {
                this.$store.dispatch("setActiveUser", { token: user.token })
                .then(async () => {
                  await this.$store.dispatch("getLoginSSO", {
                    tlc: this.formRule.tlc,
                    password: this.formRule.pass,
                  })
                  this.reloadHome()
                })
              }).catch((err)=>{
                let responses2 = Object.assign({}, err.response);
                if(responses2.data && responses2.data && responses2.data.error=="invalid_grant"){
                  localStorage.removeItem("token");
                  this.$notify.error({
                    title: `Login Failed`,
                    message: "SSO username or password is not valid!",
                  });
                  this.loading.submit = false;
                }
              })
          }).catch(()=>{
            localStorage.removeItem("token");
            this.modal.load_save = false
            this.$notify.error({
              title: `Save Signature!`,
              message:
                "Error Saving Signature!",
            });
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
html{
  scroll-behavior: smooth;
}
.page {
  display: flex;
  .card {
    &-login {
      display: flex;
      background-color: white;
      flex-direction: column;
      width: 350px;
      border-radius: $space;
      background-color: transparentize($color: white, $amount: 0.2);
      border: 1px solid darken(white, 10);
      box-shadow: 4px 4px 20px rgba($color: #000000, $alpha: 0.2);
    }
    &-header {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 60px;
      box-shadow: 0 4px 12px rgba($color: #000000, $alpha: 0.05);
    }
    &-body {
      padding: $space $space * 2;
    }
  }

  .greeting {
    text-align: center;
    margin-top: $space;
    margin-bottom: $space * 2;
    .title {
      font-size: 1.5rem;
      font-weight: 400;
      color: $primary-color;
    }
    .subtitle {
      margin: 0;
      font-size: 0.85rem;
      font-weight: 400;
      color: $subtext-color;
    }
  }

  .brand {
    height: 35px;
  }
}

.modal_nda{
  .content_nda{
    border: solid 1px #979797;
    border-radius: 5px;
    height: 65vh;
    overflow: auto;
    box-shadow: 0px 0px 5px 0px rgb(196, 195, 195);

    &.dsk{
    padding: 50px;
    }

    &.mbl{
      padding: 10px;
    }
  }
  .mtop{
    margin-top: $space;
  }
  .dsignature{
    width: auto;
    padding: 10px
  }
  .dsignature-btn{
    // margin: 0 10px 0 0;
    float: right;
  }
  .dsignature-btn2{
    margin-top: $space*2;
    width: 100%;
  }
}
</style>
